import { Navigate, Route, Routes } from 'react-router-dom';
import { SchoolCampsDashboardPage } from './SchoolCampsDashboardPage';
import { SchoolCampsBuilderPage } from './SchoolCampsBuilderPage';
import { SchoolCampsDetailPage } from './SchoolCampsDetailPage';

export function SchoolCampsSourceFaithfulRoutes() {
  return (
    <Routes>
      <Route index element={<SchoolCampsDashboardPage />} />
      <Route path="new" element={<SchoolCampsBuilderPage />} />
      <Route path=":campId" element={<SchoolCampsDetailPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
